import React, {Fragment, useState, useContext, useEffect} from 'react';
import {Modal, Tooltip, Button, Form, Input, Select, Row, Col} from 'antd';
import {PlusCircleOutlined} from '@ant-design/icons';
import {OpenApiContext} from '../openapi-context';
import pluralize from 'pluralize';

function AddInterfaceModal({visible, onAddInterface, setVisible}) {
    const {state} = useContext(OpenApiContext);
    const [schemas, setSchemas] = useState([]);
    const [form] = Form.useForm();

    const initialValues = {
        path: '',
        methods: ['get'],
        idField: 'id',
        responseTypes: ['application/json'],
    };

    async function handleOk() {
        try {
            const values = await form.validateFields();
            values.model = schemas.find((s) => s.name === values.model);
            console.log(values);
            onAddInterface(values);
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        if (state) {
            setSchemas(state.schemas());
        }
        form.resetFields();
    }, [state]);

    function handleModelChange(selectedModel) {
        const pathVal = form.getFieldValue('path');
        if (!pathVal) {
            form.setFieldsValue({path: `/${pluralize.plural(selectedModel.toLowerCase())}`});
        }
    }

    return (
        <Modal
            title="Add New Interface"
            open={visible}
            closable={true}
            destroyOnHidden
            onCancel={() => setVisible(false)}
            footer={[
                <Button key="cancel" className="addRef" onClick={() => setVisible(false)}>
                    Cancel
                </Button>,
                <Button key="submit" className="addField" type="primary" onClick={handleOk}>
                    Create
                </Button>,
            ]}>
            <Form form={form} initialValues={initialValues}>
                <Form.Item label="Model" name="model">
                    <Select style={{width: '100%'}} onChange={handleModelChange}>
                        {schemas.map((sch) => (
                            <Select.Option value={sch.name}>{sch.name}</Select.Option>
                        ))}
                    </Select>
                </Form.Item>
                <Row>
                    <Col>
                        <Form.Item
                            name="path"
                            label="Path"
                            rules={[
                                {
                                    required: true,
                                    message: 'path is required: ex: employees/{id}',
                                },
                            ]}>
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col>
                        <Form.Item name="idField" label="ID Field">
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>
                <Form.Item name="methods" label="Supported methods">
                    <Select style={{width: '100%'}} mode="multiple">
                        <Select.Option value="get">get</Select.Option>
                        <Select.Option value="post">post</Select.Option>
                        <Select.Option value="put">put</Select.Option>
                        <Select.Option value="patch">patch</Select.Option>
                        <Select.Option value="delete">delete</Select.Option>
                    </Select>
                </Form.Item>
                <Form.Item name="responseTypes" label="Response Types">
                    <Select style={{width: '100%'}} mode="multiple">
                        <Select.Option value="application/json">json</Select.Option>
                        <Select.Option value="application/xml">xml</Select.Option>
                        <Select.Option value="application/www-form-urlencoded">www-form-urlencoded</Select.Option>
                        <Select.Option value="multipart/form-data">multipart/form-data</Select.Option>
                    </Select>
                </Form.Item>
            </Form>
        </Modal>
    );
}

export function AddInterfaceDialog({onAddInterface, disabled}) {
    const [visible, setVisible] = useState();

    return (
        <Fragment>
            <Tooltip title="Add New Interface">
                <Button disabled={disabled} className="addModel" id="addInterface" type="link" size="small" onClick={() => setVisible(true)} icon={<PlusCircleOutlined />} />
            </Tooltip>
            {visible && <AddInterfaceModal visible={visible} setVisible={setVisible} onAddInterface={onAddInterface} />}
        </Fragment>
    );
}
